import { Group, Text } from "@mantine/core";
import { IconExclamationCircle } from "@tabler/icons-react";
import React from "react";

import styles from "./CustomerDroppedNotification.module.css";

export const CustomerDroppedNotification = () => {
    return (
        <Group className={styles.notificationBanner}>
            <IconExclamationCircle size={15} className={styles.notificationIcon} />
            <Text className={styles.notificationText} size="xs">
                Customer ended the call
            </Text>
        </Group>
    );
};
